import React, { useEffect } from "react";
import HomePage from "./container/HomePage/HomePage";
import "./App.css";

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.defer = true;
    script.src = "https://cloud.umami.is/script.js";
    script.dataset.websiteId = "85171c76-773a-43f4-af63-4f2294f12905";
    document.head.appendChild(script);

    const handleClick = (e) => {
      const tag = e.target.tagName.toLowerCase();
      if (["button", "a", "input", "select", "textarea"].includes(tag)) {
        window.umami?.track("click", {
          element: tag,
          properties: {
            label: e.target.textContent || e.target.value,
          },
        });
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="App">
        <HomePage />
      </div>
    </>
  );
}

export default App;
